import type React from 'react'

import { BodySmall, BodyXS } from '@/components/atomic/text'

// Icon size type
export type IconSize = 'small' | 'medium' | 'large'

// Size configurations for the banners
export const bannerSizes = {
  small: {
    container: 'min-h-[22px] px-1.5 gap-1 py-1',
    iconSize: 'small' as const,
    TextComponent: BodyXS,
  },
  medium: {
    container: 'min-h-[26px] px-2 gap-2 py-1.5',
    iconSize: 'small' as const,
    TextComponent: BodyXS,
  },
  large: {
    container: 'min-h-[32px] px-3 gap-2 py-2',
    iconSize: 'medium' as const,
    TextComponent: BodySmall,
  },
} as const

export type BannerSize = keyof typeof bannerSizes

// Props interface for Banner component
export interface BannerProps {
  variant: BannerVariant
  message: string
  rightContent?: React.ReactNode
  className?: string
  size?: BannerSize
  iconSize?: IconSize
}

export enum BannerVariant {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
